var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"find-tag"},[_c('ItemSelector',{attrs:{"items":_vm.authors,"input-placeholder":"Search for Authors","icon":"user-o","size":_vm.inputSize,"input-regexp":/^[a-zA-Z0-9 .'_-]*$/},on:{"search":_vm.load,"add":_vm.addNew}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }